jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});

document.querySelector('.t4s-cl-des-viewm').addEventListener('click', function(event) {
    event.preventDefault(); // Prevent scrolling or page reload
    let description = document.getElementById('b_{{ block.id }}');
    if (description.classList.contains('expanded')) {
        description.classList.remove('expanded');
        this.innerText = '{{ bk_stts.viewm_txt }}';
    } else {
        description.classList.add('expanded');
        this.innerText = 'View Less';
    }
});
